<template>
  <div class="h-full flex flex-col" v-loading="saveLoading">
    <div>
      <el-page-header @back="$emit('cancel')" content="安全职责承诺卡"></el-page-header>
    </div>
    <div class="flex-1 overflow-y-auto mx-200px">
      <div class="pdf-panel px-10px pt-20px" ref="card">
        <div class="w-full text-3xl text-center h-60px leading-60px bg-color-primary">
          安全职责承诺卡
        </div>
        <div class="table-form border-1">
          <table class="table-body w-full">
            <tr class="border-b-1">
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div class="text-color-primary">
                  承诺人
                </div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>{{ formData.pledgee }}</div>
              </td>

              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>岗位</div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>{{ formData.post }}</div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>主管领导</div>
              </td>
              <td class=" w-1/6 border-r-1  p-10px table-cell">
                <div>{{ formData.supervisorLeadership }}</div>
              </td>
            </tr>
            <tr class="border-b-1">
              <td class="w-1/6 border-r-1  p-10px table-cell">
                <div>承诺日期</div>
              </td>
              <td class="w-1/6 border-r-1  p-10px table-cell">
                <div>
                  {{
                    formData.commitmentTime
                      ? dayjs(formData.commitmentTime).format('YYYY-MM-DD HH:mm:ss')
                      : undefined
                  }}
                </div>
              </td>
              <td class="w-1/6 border-r-1  p-10px table-cell">
                <div>关联区域</div>
              </td>
              <td colspan="4" class="w-1/6 border-r-1  p-10px table-cell">
                <div class="text-color-primary font-normal">
                  {{ formData.associateRiskAreasStr }}
                </div>
              </td>
            </tr>
            <tr class="border-b-1">
              <td class="w-1/6 border-r-1  p-10px table-cell">
                <div>所属风险点</div>
              </td>
              <td colspan="5" class="w-1/6 border-r-1  p-10px table-cell">
                <div class="text-color-primary font-normal">
                  {{ formData.belongRiskPointStr }}
                </div>
              </td>
            </tr>
            <tr class="border-b-1">
              <td class="w-1/6 border-r-1  p-10px table-cell">
                <div>承诺内容</div>
              </td>
              <td colspan="5" class="w-1/6 border-r-1  p-10px table-cell">
                <div class="text-color-primary font-normal">
                  {{ formData.commitmentContent }}
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="flex justify-center mt-20px">
      <el-button type="primary" size="small" @click="exportRiskCard" :disabled="saveLoading"
        >导出</el-button
      >
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import html2pdf from '@/components/safety/enumField/pdfPage'
import { SecurityResponsibilityCommitmentCardApi } from '@wiz-api/double-prevention-management'

const securityResponsibilityCommitmentCardApi = new SecurityResponsibilityCommitmentCardApi()
export default {
  name: 'safe-duty-card',
  components: {},
  props: {
    rowId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      saveLoading: false,
      formData: {
        id: undefined,
        pledgeeId: undefined,
        pledgee: '',
        postId: undefined,
        post: '',
        belongRiskPoint: undefined,
        belongRiskPointStr: '',
        riskPointNumber: undefined,
        associateRiskAreas: undefined,
        associateRiskAreasStr: '',
        supervisorLeadershipId: undefined,
        supervisorLeadership: '',
        commitmentTime: undefined,
        commitmentContent: '',
        annex: undefined,
      },
    }
  },
  created() {
    this.initForm()
  },
  methods: {
    // 初始化表单
    async initForm() {
      this.saveLoading = true
      const [err, res] = await securityResponsibilityCommitmentCardApi.get(this.rowId)
      if (!err) {
        this.formData = {
          ...this.formData,
          ...res,
        }
      }
      this.saveLoading = false
    },
    // 导出pdf
    exportRiskCard() {
      const pdfName = '安全职责承诺卡'
      html2pdf(this.$refs.card, pdfName)
    },
  },
}
</script>

<style scoped lang="scss">
.table-form {
  td:last-child {
    border-right: none;
  }
  .table-body {
    word-break: break-all;
    font-size: 14px;
    tr:last-child {
      border: none;
    }
    td:first-child {
      border-left: none;
    }
  }
}

::v-deep .el-card .el-card__header {
  padding: 10px;
}

::v-deep .custom-card {
  border-bottom: none !important;
}

::v-deep .el-card .el-card__header {
  padding: 0 !important;
}
</style>
